module.exports = __webpack_public_path__ + "static/baptist_health_south_florida.37932cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/baptist_health_south_florida.png
// module id = 2168
// module chunks = 61762850755587